import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CsvService {
  exportCSV(csvString: string, fileType: string): void {
    const universalBOM = '\uFEFF';
    const hiddenElement = window.document.createElement('a');
    hiddenElement.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
    const timestampNow = moment().format('L');
    hiddenElement.setAttribute('download', `${fileType}_${timestampNow}.csv`);
    window.document.body.appendChild(hiddenElement);
    hiddenElement.click();
  }
}
